export const selectAuthUserData = (state) => state.auth.userData;
export const selectAuthIsLoading = (state) => state.auth.isLoading;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthToken = (state) => state.auth.token;
export const selectAuthIsRefreshing = (state) => state.auth.isRefreshing;
export const selectAuthIsLoggedIn = (state) => state.auth.isLoggedIn;
